import React from 'react'
import './index.scss'
import { ICONS } from '@Const/common'

interface AddPlaceButtonProps {
    title?: string

    onClick?(): void
}

const AddPlaceButton = ({ title, onClick }: AddPlaceButtonProps) => (
    <div className="add-place-button" style={onClick ? { cursor: 'pointer' } : undefined} onClick={onClick}>
        <div className="background">
            <div className="icon">
                <img src={ICONS.add} alt="add" />
            </div>

            {title && <span>{title}</span>}
        </div>
    </div>
)

export default AddPlaceButton
